// import type { CartError } from '~/types/shopware'

const successCodes = ['promotion-discount-added']

export type UseCmsHeadReturn = {
  codeErrorsNotification(): void
}

/**
 * UI composable
 *
 * @returns
 */
export function useCartNotification() {
  const { pushError, pushSuccess } = useNotifications()
  const { consumeCartErrors } = useCart()

  /**
   * Get cart error and display
   *
   * @returns {void}
   */
  const codeErrorsNotification = () => {
    const errors = consumeCartErrors()
    if (!errors) return

    // Handle both array and object formats
    const errorItems = Array.isArray(errors) ? errors : Object.values(errors)
    if (!errorItems.length) return

    errorItems.forEach((error) => {
      if (successCodes.includes(error.messageKey)) {
        pushSuccess(error.message)
      } else {
        pushError(error.message)
      }
    })
  }

  return {
    codeErrorsNotification,
  }
}
